import { render, staticRenderFns } from "./vendorPriceMenuUpdate.vue?vue&type=template&id=3934ec66&scoped=true"
import script from "./vendorPriceMenuUpdate.vue?vue&type=script&lang=js"
export * from "./vendorPriceMenuUpdate.vue?vue&type=script&lang=js"
import style0 from "./vendorPriceMenuUpdate.vue?vue&type=style&index=0&id=3934ec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3934ec66",
  null
  
)

export default component.exports